import React, { JSX } from "react";
import styled from "styled-components";
import { PlusIcon } from "@ui/components/icons";

interface BigPlusButtonProps extends React.HTMLAttributes<HTMLDivElement> {
	label?: string;
	icon?: JSX.Element;
}
export const BigPlusButton: React.FC<BigPlusButtonProps> = ({ label, icon, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			{label && <div>{label}</div>}
			{icon ?? <PlusIcon />}
		</Container>
	);
};

const Container = styled.div`
	cursor: pointer;
	${({ theme }) => theme.containerStyles.roundedBlockStyle};
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 40px;

	> div {
		${({ theme }) => theme.textStyles.primary};
		margin-right: 6px;
	}

	svg path {
		fill: ${({ theme }) => theme.colors.textPrimary};
	}
`;
